"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotAuthorized = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@material-ui/core");
const react_1 = tslib_1.__importDefault(require("react"));
const NotAuthorized = () => (react_1.default.createElement(core_1.Container, { maxWidth: "sm" },
    react_1.default.createElement(core_1.Typography, { component: "h1", gutterBottom: true }, "Authorization"),
    react_1.default.createElement(core_1.Typography, { variant: "body1" }, "You are not authorized to access this resource.")));
exports.NotAuthorized = NotAuthorized;
//# sourceMappingURL=not-authorized.js.map